import apiInstance from "../../api-config/axios-instance";

export function SearchProduct(payload) {
  const { search } = payload;

  if (search) {
    const response = apiInstance.get(`/product/all?search=${search.toString()}`);
    return response;
  }
}
